// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactDOMRe = require("reason-react/src/ReactDOMRe.js");

function cellStyle(cellSize) {
  return {
          background: "#bdbdbd",
          border: "3px solid #fcfcfc",
          borderRightColor: "#7a7a7a",
          borderBottomColor: "#7a7a7a",
          height: cellSize,
          width: cellSize
        };
}

var matrixStyle = {
  border: "0 solid lightgray",
  borderTopWidth: "1px",
  borderLeftWidth: "1px",
  display: "inline-block"
};

function Matrix(Props) {
  var value = Props.value;
  var cellSizeOpt = Props.cellSize;
  var styleOpt = Props.style;
  var onCellClickOpt = Props.onCellClick;
  var cellSize = cellSizeOpt !== undefined ? cellSizeOpt : "20px";
  var style = styleOpt !== undefined ? styleOpt : (function (param, param$1) {
        return { };
      });
  var onCellClick = onCellClickOpt !== undefined ? onCellClickOpt : (function (param, param$1, param$2) {
        return /* () */0;
      });
  return React.createElement("div", {
              style: matrixStyle
            }, value.map((function (row, y) {
                    return React.createElement("div", {
                                key: String(y),
                                style: {
                                  display: "flex"
                                }
                              }, row.map((function (el, x) {
                                      return React.createElement("div", {
                                                  key: String(x),
                                                  className: "Matrix__cell",
                                                  style: ReactDOMRe.Style.combine(cellStyle(cellSize), Curry._2(style, /* tuple */[
                                                            x,
                                                            y
                                                          ], el)),
                                                  onClick: (function (e) {
                                                      return Curry._3(onCellClick, e, /* tuple */[
                                                                  x,
                                                                  y
                                                                ], el);
                                                    })
                                                });
                                    })));
                  })));
}

var make = Matrix;

exports.cellStyle = cellStyle;
exports.matrixStyle = matrixStyle;
exports.make = make;
/* react Not a pure module */
